import DateTimePicker from "@/Components/Scheduling/DateTimePicker/DateTimePicker";
import DataLoadingModal from "@/Components/UI/DataLoadingModal";
import { LoadsLifeAreas } from "@/types/lifeArea";
import { LoadsMatchingAttributes } from "@/types/matchingAttribute";
import { Client, Coach, None, PageProps } from "@/types/page";
import { LoadsReviews } from "@/types/review";
import { coachWithCerts } from "@/utils/fullUserNames";
import { isSecondBiteFlow } from "@/utils/secondBiteScheduling";
import { usePage } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import { useState } from "react";
import { SchedulerData } from "../../Scheduler";

type AvailabilityModalProps = {
    show: boolean;
    setShow: (show: boolean) => void;
    coach: Coach & LoadsLifeAreas & LoadsReviews & LoadsMatchingAttributes;
    onSecondBiteSelect?: () => void;
};

export default function AvailabilityModal({
    show,
    setShow,
    coach,
    onSecondBiteSelect,
}: AvailabilityModalProps) {
    const user = usePage<PageProps<None, Client | Coach>>().props.user;

    const [schedulerModalData, setSchedulerModalData] =
        useState<SchedulerData>();

    const viewOnly = !isSecondBiteFlow();

    const handleAppointmentSelection = async (slot: {
        start: string;
        end: string;
    }) => {
        if (user?.type === "client" && user.has_payment_setup === false) {
            try {
                await window.axios.post(
                    route("second-bite.cache-appointment", {
                        coach: coach.id,
                    }),
                    {
                        start_at: slot.start,
                        end_at: slot.end,
                    },
                );
            } catch (error) {
                Sentry.captureException(error);
            }
        }
        onSecondBiteSelect?.();
    };

    return (
        <DataLoadingModal
            id="try-coach-scheduler"
            onClose={() => setShow(false)}
            show={show}
            maxWidth="5xl"
            closeable={true}
            showCloseButton={true}
            animateClose={false}
            route={route("getSchedulerData", coach.id)}
            finishedLoadingCallback={setSchedulerModalData}
            modalData={schedulerModalData}
        >
            {schedulerModalData && (
                <div className="flex flex-col items-center gap-4 p-6 sm:p-8">
                    <div className="text-center text-xl font-bold">
                        View {coachWithCerts(coach)}'s availability
                    </div>
                    <div className="max-w-full">
                        <DateTimePicker
                            schedulerData={schedulerModalData}
                            onAppointmentSelection={handleAppointmentSelection}
                            recurringIntervalCount={null}
                            coach={coach}
                            viewOnly={viewOnly}
                            hideHeading={true}
                        />
                    </div>
                </div>
            )}
        </DataLoadingModal>
    );
}
